export function CPCompare(param1, param2) {
  if (!param1 || !param2) return false;

  var keys1 = Object.keys(param1);
  var keys2 = Object.keys(param2);

  if (keys1.length !== keys2.length) {
    return false;
  }

  return keys1.every(key => param1[key] === param2[key]);
}
